
<template>
  <!--人员预警记录-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="open_log_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_h" slot-scope="{row}">
        <a-tooltip>
          <template slot="title">{{row.sys_label}}</template>
          <span type="link" style="cursor: pointer">{{row.sys_label.split('/').slice(0,3).join('/')}}</span>
        </a-tooltip>
      </template>

      <template slot="opt_t" slot-scope="{row}">
        <a-button @click="openLog(row)" type="link">{{row.true_name}}</a-button>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'blackListRecord',
  data () {
    return {
      listInterval: '',
      searchList: [
        { props: ['keywords'], placeholder: '姓名、手机号', options: [], inputType: 'input' },
        {
          props: ['area_id'],
          placeholder: '区域',
          options: [],
          inputType: 'cascader',
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(1, 'searchList', '1,2,3', e);
          }
        },
        { props: ['community_id'], placeholder: '小区', options: [], inputType: 'select' },
        { props: ['sys_label'], placeholder: '标签', options: [], inputType: 'select' },
        { props: ['create_date'], placeholder: ['开始时间', '结束时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '查看', handle: (row) => this.showPicture(row.face_img), key: 'show' }
      ],
      columns: [
        { title: '姓名', dataIndex: 'true_name', align: 'left', width: '7%', scopedSlots: {customRender: 't'} },
        { title: '标签', dataIndex: 'sys_label', align: 'left', width: '', scopedSlots: {customRender: 'h'} },
        { title: '开门时间', dataIndex: 'open_time', align: 'left', width: '' },
        { title: '所在小区', dataIndex: 'community_name', align: 'left', width: '' },
        { title: '通行门', dataIndex: 'position_name', align: 'left', width: '' },
        { title: '设备名称', dataIndex: 'device_name', align: 'left', width: '' },
        { title: '账号', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '卡号', dataIndex: 'cardno', align: 'left', width: '' },
        { title: '开门方式', dataIndex: 'open_type_desc', align: 'left', width: '9%' },
        { title: '抓拍', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: undefined,
        area_id: undefined,
        community_id: undefined,
        sys_label: undefined,
        create_date: undefined
      },
      listApi: {
        url: '/blacklist/open_log/',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {}
    };
  },
  created () {
    this.getSelect();
  },
  beforeDestroy () {
    clearInterval(this.listInterval);
  },
  methods: {
    getSelect () {
      this.regionSelect(1, 'searchList');
      this.communitySelect(2, 'searchList', 1);
      this.typeSelect({
        query: 'sys_label',
        handle: (data) => {
          this.searchList[3].options = data;
        }
      });
    },
    /* 开门日志 */
    openLog (row) {
      this.$router.push({
        name: 'lookOpenLog',
        query: {
          id: row.member_id,
          name: row.true_name,
          label: row.sys_label
        }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
